// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { getCreateAcountState } from "@store/Framework/Store/Store/Pages/CreateAccount/StoreCreateAccountSelectors";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, PopulateApiParameter, props => {
    /* Store Custom Code - Start */
    const createAccountState = getCreateAcountState(props.getState());
    /* Store Custom Code - End */

    props.apiParameter = {
        account: {
            ...props.parameter,
            // Store Custom Code
            properties: {
                customerLookup: createAccountState.customerNumber,
                postalCode: createAccountState.postalCode,
            },
        } as unknown as AccountModel,
    };
});
